import * as actions from './actions'

const catalogLocalitiesModule = {
    namespaced: true,
    actions,
}

export default catalogLocalitiesModule
